import { NavLink, Outlet, Link } from "react-router-dom";
import { Activity, Boxes, Calculator, Truck, ShoppingCart, Undo2, Megaphone, Bot, ShieldAlert, Palette, ScrollText, Power, Store, MessageSquare, Facebook } from "lucide-react";
import { useLoad, act } from "./ui";
import { api } from "../../lib/api";
import { useApp } from "../../context/AppContext";

const NAV = [
  ["", "Tableau de bord", Activity], ["pipeline", "Produits", Boxes], ["pricing", "Moteur de prix", Calculator],
  ["suppliers", "Fournisseurs & stocks", Truck], ["orders", "Commandes", ShoppingCart], ["refunds", "Remboursements", Undo2], ["reviews", "Avis clients", MessageSquare], ["facebook", "Facebook", Facebook],
  ["campaigns", "Publicité", Megaphone], ["agents", "Agents IA", Bot], ["controls", "Contrôles & autonomie", ShieldAlert],
  ["brands", "Marques & marchés", Palette], ["site", "Apparence & textes", Store], ["audit", "Audit & alertes", ScrollText],
];

function TopBar() {
  const [s, reload] = useLoad("/admin/settings");
  const { user } = useApp();
  const g = s?.kill?.global;
  const toggle = async () => {
    if (!g && !window.confirm("Activer l'ARRÊT D'URGENCE global ? Toutes les automatisations, ventes, publicités et remboursements seront bloqués.")) return;
    await act(() => api.put("/admin/settings/kill", { domain: "global", value: !g }), g ? "Arrêt d'urgence levé" : "ARRÊT D'URGENCE ACTIVÉ");
    reload();
  };
  return (
    <div className="h-14 border-b border-[#1E222D] flex items-center gap-4 px-6 sticky top-0 z-40 backdrop-blur-md bg-[#08090C]/80">
      <span className={`w-2 h-2 rounded-full pulse-dot ${g ? "bg-red-500" : "bg-emerald-500"}`} />
      <span className="font-mono text-xs" data-testid="system-state">{g ? "SYSTÈME ARRÊTÉ" : "SYSTÈME OPÉRATIONNEL"}</span>
      <span className="font-mono text-xs text-slate-500" data-testid="autonomy-level-indicator">Autonomie N{s?.autonomy_level ?? "-"} · planificateur {s?.scheduler_enabled ? "ON" : "OFF"}</span>
      <div className="ml-auto flex items-center gap-4">
        <span className="text-xs text-slate-500 hidden md:inline">{user.email} · {user.role}</span>
        <button data-testid="global-kill-switch" onClick={toggle} className={`flex items-center gap-2 px-3 py-1.5 text-xs font-mono font-bold border transition-colors ${g ? "bg-red-600 border-red-500 text-white" : "border-red-500/50 text-red-400 hover:bg-red-500/10"}`}>
          <Power className="w-3.5 h-3.5" />{g ? "LEVER L'ARRÊT" : "ARRÊT D'URGENCE"}
        </button>
      </div>
    </div>
  );
}

export default function AdminLayout() {
  return (
    <div className="admin-surface min-h-screen flex text-slate-100 relative z-10">
      <aside className="w-60 shrink-0 border-r border-[#1E222D] hidden md:flex flex-col sticky top-0 h-screen">
        <div className="h-14 flex items-center px-5 border-b border-[#1E222D] font-display font-extrabold">À L'ABRI <span className="label-xs ml-2">admin</span></div>
        <nav className="flex-1 overflow-y-auto py-3">
          {NAV.map(([to, label, Icon]) => (
            <NavLink key={to} end={to === ""} to={`/admin${to ? `/${to}` : ""}`} data-testid={`admin-nav-${to || "dashboard"}`}
              className={({ isActive }) => `flex items-center gap-3 px-5 py-2.5 text-sm transition-colors ${isActive ? "text-emerald-400 bg-emerald-500/5 border-l-2 border-emerald-500" : "text-slate-400 hover:text-white border-l-2 border-transparent"}`}>
              <Icon className="w-4 h-4" />{label}
            </NavLink>
          ))}
        </nav>
        <Link to="/" data-testid="admin-to-store" className="flex items-center gap-2 px-5 py-4 border-t border-[#1E222D] text-xs text-slate-400 hover:text-white"><Store className="w-4 h-4" /> Voir la boutique</Link>
      </aside>
      <div className="flex-1 min-w-0">
        <TopBar />
        <div className="md:hidden flex overflow-x-auto gap-2 px-4 py-2 border-b border-[#1E222D]">
          {NAV.map(([to, label]) => <NavLink key={to} end={to === ""} to={`/admin${to ? `/${to}` : ""}`} className="text-xs whitespace-nowrap px-2 py-1 border border-[#1E222D]">{label}</NavLink>)}
        </div>
        <main className="p-6 md:p-10"><Outlet /></main>
      </div>
    </div>
  );
}
